import http from "./apiClient";

export const getNoctisStatus = async () => {
  const res = await http.get("/noctis/status");
  return res?.data;
};

